import React from 'react'
import { useParams } from 'react-router-dom'
import loadComponent from 'src/utils/loadMFE'
import RouteContainer from 'src/components/App/RouteContainer'

const TrainingDetails = React.lazy(() => loadComponent('traiwiss', 'TrainingDetails'))

export function TrainingDetailsRoute() {
    const params = useParams()

    return (
        <RouteContainer>
            <TrainingDetails _id={params._id} />
        </RouteContainer>
    )
}
